import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { Empresa } from 'service/api'
import { CreateSlice } from './index'

export type DateSelectors = {
    /** Competência atual da empresa selecionada */
    competenciaAtual: string
    /** Competência selecionada pelo usuário */
    competencia: string
    setCompetencia: {
        (data: Empresa): void
        (data: string): void
    }
}

export const createDateSelectorsSlice: CreateSlice<DateSelectors> = set => {
    const instance = dayjs().locale('pt-br')

    return {
        competenciaAtual: instance.format('YYYY-MM'),
        competencia: instance.format('YYYY-MM'),
        setCompetencia: data => {
            if (typeof data === 'string') {
                set({
                    competencia: data,
                })
            }

            if (
                typeof data === 'object' &&
                typeof data.competenciaAtual === 'string'
            ) {
                set({
                    competenciaAtual: data.competenciaAtual!,
                })
            }
        },
    }
}
